module.exports = __webpack_public_path__ + "static/Innovation-ff5a4d28987ae20566d17b0dcf9eaf8a.svg";